angular = require('angular')

module.exports =
  angular
  .module('App.Core.Components.ScheduleBreak', [])

  .component('scheduleBreaksList', require('./list'))
  .component('scheduleBreakForm', require('./form'))
  .component('scheduleBreakSave', require('./save'))
